export const QUERY_KEYS = {
  USER: {
    GET_USER_DETAILS: 'GET_USER_DETAILS',
    USER_LIST: 'USER_LIST',
    PERMISSIONS: 'PERMISSIONS',
  },
  WORKSPACE: {
    SELECT_WORKSPACE_LIST: 'SELECT_WORKSPACE_LIST',
    SELECT_WORKSPACE: 'SELECT_WORKSPACE',
    ALL_WORKSPACES: 'ALL_WORKSPACES',
    CLIENT_HIERARCHY: 'CLIENT_HIERARCHY',
    GET_CURRENT_WORKSPACE: 'GET_CURRENT_WORKSPACE',
    WORKSPACE_LIST: 'WORKSPACE_LIST',
    BULK_CREATION_REPORTS: 'BULK_CREATION_REPORTS',
  },
  BRAND_LIBRARY: {
    BRAND_ASSETS_LIST: 'BRAND_ASSETS_LIST',
  },
  ROLES: {
    ROLE_LIST: 'ROLE_LIST',
  },
  KNOWLEDGE_ATTRIBUTE: {
    KNOWLEDGE_ATTRIBUTE_LIST: 'KNOWLEDGE_ATTRIBUTE_LIST',
  },
  HIERARCHY: {
    ASSETS_HIERARCHY: 'ASSETS_HIERARCHY',
  },
  CUSTOMER: {
    GET_CUSTOMER: 'GET_CUSTOMER',
  },
  INTEGRATIONS: {
    GET_INTEGRATION_STATUS: 'GET_INTEGRATION_STATUS',
    GET_API_KEYS: 'GET_API_KEYS',
    GET_SUBSCRIPTION_WORKSPACES: 'GET_SUBSCRIPTION_WORKSPACES',
  },
  LABELS: {
    LABEL_LIST: 'LABEL_LIST',
    LABEL_USAGE_COUNT: 'LABEL_USAGE_COUNT',
  },
};
